import { WorkflowStepDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { ReactFlowProvider } from "reactflow";
import { SetupWorkflowHeader } from "./components/setup-workflow-header";
import ModuleFlow from "./components/side-bar-configuration-module-flow";
import WorkflowGraph from "./components/work-flow-graph";
import { useWorkflowForm } from "./hooks/use-workflow-form";
import { useWorkflowContext } from "./use-workflow-context";

export function WorkflowEditFlow() {
  const t = useTranslation();
  const { currentWorkflow } = useWorkflowContext();
  const {
    onSubmit,
    form,
    deleteStep,
    addStep,
    onSelectStep,
    selectedStep,
    getFormValue,
    deleteSelectedStep,
    setSelectedStep,
    saveActionStep,
    saveTriggerStep,
  } = useWorkflowForm({
    currentWorkflow,
  });

  useEffect(() => {
    form.reset(currentWorkflow);
  }, [currentWorkflow]);

  return (
    <div className="h-full w-full">
      <div className="flex flex-col h-full mx-auto">
        <FormProvider {...form}>
          <form className="flex flex-1" onSubmit={onSubmit}>
            <div className="relative flex-1 h-full">
              <SetupWorkflowHeader />
              <div className="h-full ">
                <ReactFlowProvider>
                  <WorkflowGraph
                    newStep={addStep}
                    steps={[getFormValue("trigger") as WorkflowStepDto].concat(
                      getFormValue("steps") as WorkflowStepDto[],
                    )}
                    selectedStep={selectedStep}
                    onDelete={deleteStep}
                    onSelect={onSelectStep}
                  />
                </ReactFlowProvider>
              </div>
            </div>
            <div className="h-full w-80">
              {selectedStep ? (
                <ModuleFlow
                  shopId={currentWorkflow.shopId}
                  flowStep={selectedStep}
                  onDelete={deleteSelectedStep}
                  onCancel={() => setSelectedStep(undefined)}
                  onSaveAction={saveActionStep}
                  onSaveTrigger={saveTriggerStep}
                />
              ) : (
                <div className="h-full flex bg-white  text-gray-400 shadow-md  p-3   justify-center place-items-center">
                  <>{t("workflow.module.select")}</>
                </div>
              )}
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}
